app.controller("RemindersCreateModalController", [
    "$scope", "$timeout", "RemindersService", "$uibModalInstance", "AuthService", "params", "$uibModalInstance", "toastr",
    function ($scope, $timeout, RemindersService, $uibModal, AuthService, params, $uibModalInstance, toastr) {
        $scope.text = params.text || '';
        $scope.editableText = params.editableText || false;
        $scope.months = [
            '01',
            '02',
            '03',
            '04',
            '05',
            '06',
            '07',
            '08',
            '09',
            '10',
            '11',
            '12'
        ];

        $scope.days = [];
        for (var i = 1; i <= 28; i++) {
            if (i < 10) {
                $scope.days.push('0' + i);
            } else {
                $scope.days.push('' + i);
            }
        }

        $scope.selectedMonth = '';
        $scope.selectedDay = '';
        $scope.dates = [];

        $scope.add = function () {
            if(!$scope.selectedMonth || !$scope.selectedDay){
                toastr.warning('აირჩიეთ ორივე ველი');
                return;
            }
            $scope.dates.push({
                day: $scope.selectedDay,
                month: $scope.selectedMonth
            });
            $scope.selectedMonth = '';
            $scope.selectedDay = '';
        };

        $scope.delete = function (givenDate) {
            for (var i = 0; i < $scope.dates.length; i++) {
                if (givenDate.day === $scope.dates[i].day && givenDate.month === $scope.dates[i].month) {
                    $scope.dates.splice(i, 1);
                    return;
                }
            }
        };

        $scope.create = function () {
            if($scope.dates.length === 0) {
                toastr.warning('შეიყვანეთ მინიმუმ 1 თარიღი');
                return;
            }

            RemindersService.create({
                dates: $scope.dates,
                route: params.route,
                routeParams: params.routeParams,
                text: $scope.text,
                type: params.type
            }).then(function () {
                toastr.success('შემხსენებელი შექმნილია');
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
